

export class JkPopup{
  private _popupVisible = false;
  get popupVisible(): boolean {
    return this._popupVisible;
  }
  set popupVisible(value: boolean) {
    this._popupVisible = value;
  }
  popUpWidth: number;
  popUpHeight: number;
  WidthBorder: number;
  //isInsert: boolean;
  //ownerPage: any;
  //cbResult: boolean;
  //cbOk: (e:any,pop:JkPopup) => void; // doOk callback
  constructor(){
    //this.ownerPage = ownerPage;
    this.popUpWidth = 800;
    this.popUpHeight = 800;
    this.WidthBorder = 50;// 與邊界距離
  }
  /*
  show(isInsert:boolean){
    //this.isInsert = isInsert;
    this.popupVisible = true;
  }*/
  /*
  async ok(e){
    this.cbResult = false;
    await this.cbOk(this.ownerPage,this);
    if(this.cbResult){
      this.hide(e);
    };
  }*/
  /*
  hide(e){
    this.popupVisible = false;
  }*/
}
